import React, { Component } from 'react';
import { Grid, Select, MenuItem, TextareaAutosize, Button, FormControl, Typography } from '@material-ui/core';

type BaseUpdateCatalogueOption = {
    optionId: number,
    label: string
}

type UpdateCatalogueOption = {
    description: string
} & BaseUpdateCatalogueOption

export type UpdateCatalogueOptionFilled = {
    text: string
}& BaseUpdateCatalogueOption


const defaultOption = { optionId: 0, label: "There is no category matching my product", description: "Specify your product & new category proposition." }
const updateCatalogueOptions: UpdateCatalogueOption[] = [
    defaultOption,
    { optionId: 1, label: "There is no property describing properly my product", description: "Specify the missing property & possible property optionIds." },
    { optionId: 2, label: "There is a mistake", description: "Describe the mistake" }
]


type State = {
    selectedOption: UpdateCatalogueOption | null,
    requestText: string,
    propositionSent: boolean
}

type Props = {
    onCancel: () => void,
    onSend: (request: UpdateCatalogueOptionFilled) => void
}

class UpdateCatalogueRequest extends Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            selectedOption: defaultOption,
            requestText: '',
            propositionSent: false
        }
    }
    render() {
        return (
            <Grid container >
                {this.state.propositionSent ?
                    <Grid item style={{width: '100%', textAlign: 'center'}}>
                        <Typography variant="h4">Thank you for your feedback, we will keep you posted!</Typography>
                    </Grid>
                    :
                    <Grid item style={{ width: '100%' }}>
                        <FormControl style={{ width: '100%', padding: '10px 7.5px 15px 7.5px' }}>
                            <Select
                                inputProps={{
                                    id: "update-select"
                                }}
                                style={{ fontSize: '1.25em' }}
                                value={this.state.selectedOption === null ? 0 : this.state.selectedOption.optionId}
                                onChange={(e) => this.setState({ selectedOption: updateCatalogueOptions.find(u => u.optionId === Number(e.target.value)) || null })}
                                name="update-catalog">
                                {updateCatalogueOptions.map((k, i) => {
                                    return <MenuItem key={i} value={k.optionId}>{k.label}</MenuItem>
                                })}
                            </Select>
                        </FormControl>
                        {this.state.selectedOption !== null &&
                            <div>
                                <TextareaAutosize maxLength={1000} style={{ width: '100%' }} rows={3} placeholder={this.state.selectedOption!.description} value={this.state.requestText} onChange={(e) => this.setState({ requestText: e.target.value })} />
                                <Button size="small" variant="outlined" style={{ margin: '5px' }} onClick={this.props.onCancel}>Cancel</Button>
                                <Button size="small" variant="contained" style={{ margin: '5px' }} color="primary" disabled={this.state.requestText.length < 3} onClick={() => { this.setState({ propositionSent: true }); this.props.onSend({optionId: this.state.selectedOption!.optionId, label: this.state.selectedOption!.label, text: this.state.requestText}) }}>Send!</Button>
                            </div>
                        }
                    </Grid>
                }
            </Grid>
        );
    }
}

export default UpdateCatalogueRequest;